const comments = [
  {
    name: '吃瓜群众小明',
    time: '2小时前',
    content: '这个瓜太大了，信息量爆炸！黑料入口整理得特别清晰，终于把整个事件的时间线搞清楚了，吃瓜吃得明明白白。',
    tag: '娱乐圈黑料',
  },
  {
    name: '深夜瓜农',
    time: '5小时前',
    content: '每天必刷黑料入口，比刷微博还有意思。关键是这里的黑料故事都经过整理，不是那种碎片化的小道消息，很有参考价值。',
    tag: '大厂内幕',
  },
  {
    name: '真相追踪者',
    time: '8小时前',
    content: '终于有人把这些黑料认真梳理了！以前看各种爆料都是东一榔头西一棒子，现在在黑料入口能看到完整的叙事和后续跟踪。',
    tag: '瓜田故事',
  },
  {
    name: '吃瓜老手',
    time: '12小时前',
    content: '黑料入口的质量在吃瓜黑料网站里真的算顶尖了。不光有故事，还有深度分析和相关话题关联，这才是专业的黑料揭秘方式。',
    tag: '黑料揭秘',
  },
  {
    name: '热点猎人',
    time: '1天前',
    content: '推荐给了身边所有爱吃瓜的朋友！黑料入口的热度榜单特别实用，一下就知道了最近哪些黑料最值得关注，省得自己去到处扒。',
    tag: '黑料跟踪',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          瓜友热评
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          来看看吃瓜群众们都在聊什么
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200/60 rounded-lg p-5"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-primary-500/15 flex items-center justify-center">
                    <span className="text-xs font-bold text-primary-400">
                      {comment.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-200">{comment.name}</p>
                    <p className="text-xs text-foreground-500">{comment.time}</p>
                  </div>
                </div>
                <span className="text-xs text-accent-400 bg-accent-500/10 px-2 py-0.5 rounded-full whitespace-nowrap">
                  {comment.tag}
                </span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}